function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Checkbox } from "./Checkbox";
import { Text } from "./Text";
import { TextInput } from "./TextInput";
import { View } from "./View";
import { AccessibleInput } from "../hooks/useAccessibleInput";
import { useTheme } from "../styles";
/**
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-75}
 */ export function CheckboxListInput(props) {
    var theme = useTheme().theme;
    var _props_arialabel;
    return /*#__PURE__*/ _jsx(AccessibleInput, {
        "aria-label": (_props_arialabel = props['aria-label']) !== null && _props_arialabel !== void 0 ? _props_arialabel : props.label,
        label: props.label ? function() {
            var _props_label, _props_label1;
            var _props_labelSize;
            return /*#__PURE__*/ _jsxs(View, {
                style: {
                    marginLeft: -16,
                    marginBottom: props.hideHint ? 5 : 20
                },
                spacing: 10,
                children: [
                    /*#__PURE__*/ _jsxs(Text, {
                        role: "none",
                        text: "",
                        weight: "semibold",
                        size: (_props_labelSize = props.labelSize) !== null && _props_labelSize !== void 0 ? _props_labelSize : 21,
                        children: [
                            (_props_label = props.label) === null || _props_label === void 0 ? void 0 : _props_label.replace(/\*$/, ''),
                            ((_props_label1 = props.label) === null || _props_label1 === void 0 ? void 0 : _props_label1.endsWith('*')) ? /*#__PURE__*/ _jsx(Text, {
                                text: " *",
                                color: theme.color.danger,
                                weight: "semibold"
                            }) : null
                        ]
                    }),
                    props.hideHint ? null : /*#__PURE__*/ _jsx(Text, {
                        text: "Check any that apply"
                    })
                ]
            });
        } : undefined,
        labelWeight: props.labelWeight,
        testID: props.testID,
        error: props.error,
        children: function(accessibleProps) {
            return /*#__PURE__*/ _jsx(View, _object_spread_props(_object_spread({}, accessibleProps), {
                style: {
                    gap: 10
                },
                role: "combobox",
                accessibilityHint: "Check any that apply",
                "aria-disabled": props.disabled,
                testID: props.testID,
                children: Object.entries(props.items).map(function(item, i) {
                    var _props_followups, _props_customLabels, _props_followupsValue;
                    var _item = _sliced_to_array(item, 2), key = _item[0], label = _item[1];
                    var isChecked = props.value.includes(key);
                    var _props_followups_key;
                    var question = (_props_followups_key = (_props_followups = props.followups) === null || _props_followups === void 0 ? void 0 : _props_followups[key]) !== null && _props_followups_key !== void 0 ? _props_followups_key : props.defaultFollowup;
                    var _props_optionLabelWeight;
                    return /*#__PURE__*/ _jsxs(View, {
                        children: [
                            /*#__PURE__*/ _jsx(Checkbox, {
                                horizontal: true,
                                onChangeValue: function(newValue) {
                                    return props.onChangeValue(newValue ? _to_consumable_array(props.value).concat([
                                        key
                                    ]) : props.value.filter(function(v) {
                                        return v !== key;
                                    }));
                                },
                                label: (props === null || props === void 0 ? void 0 : (_props_customLabels = props.customLabels) === null || _props_customLabels === void 0 ? void 0 : _props_customLabels[label]) || label,
                                labelWeight: (_props_optionLabelWeight = props.optionLabelWeight) !== null && _props_optionLabelWeight !== void 0 ? _props_optionLabelWeight : props.labelWeight,
                                size: props.checkboxSize,
                                value: isChecked,
                                testID: "".concat(props.testID, "_choice_").concat(i),
                                disabled: props.disabled
                            }),
                            isChecked && question ? /*#__PURE__*/ _jsx(View, {
                                style: {
                                    marginLeft: 32
                                },
                                children: /*#__PURE__*/ _jsx(TextInput, {
                                    testID: "".concat(props.testID, "_choice_").concat(i, "_followupInput"),
                                    placeholder: question,
                                    value: (_props_followupsValue = props.followupsValue) === null || _props_followupsValue === void 0 ? void 0 : _props_followupsValue[key],
                                    onChangeValue: function(newV) {
                                        var value = _object_spread_props(_object_spread({}, props.followupsValue), _define_property({}, key, newV));
                                        if (newV) {
                                            var _props_onChangeFollowupsValue;
                                            (_props_onChangeFollowupsValue = props.onChangeFollowupsValue) === null || _props_onChangeFollowupsValue === void 0 ? void 0 : _props_onChangeFollowupsValue.call(props, value);
                                        } else {
                                            var _props_onChangeFollowupsValue1;
                                            delete value[key];
                                            (_props_onChangeFollowupsValue1 = props.onChangeFollowupsValue) === null || _props_onChangeFollowupsValue1 === void 0 ? void 0 : _props_onChangeFollowupsValue1.call(props, value);
                                        }
                                    },
                                    disabled: props.disabled
                                })
                            }) : null
                        ]
                    }, key);
                })
            }));
        }
    });
}
/**
 * @nosync
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-75}
 */ export var CheckboxListInputRender = function(renderProps, props) {
    var _renderProps_field = renderProps.field, onChange = _renderProps_field.onChange, onBlur = _renderProps_field.onBlur, value = _renderProps_field.value, name = _renderProps_field.name, error = renderProps.fieldState.error;
    return /*#__PURE__*/ _jsx(CheckboxListInput, _object_spread({
        testID: "FormInput_".concat(name.replaceAll('.', '_')),
        onChangeValue: function(v) {
            onChange(v);
            onBlur();
        },
        value: value,
        error: error === null || error === void 0 ? void 0 : error.message
    }, props));
};
